// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo_logo__1q8rq","light":"logo_light__1rAyr","bold":"logo_bold__3RcIU"};